import { Injectable, Injector } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Checklist } from 'src/app/models/atividade.model';
import { LookupItem } from 'src/app/services/lookup.service';
import { UtilService } from 'src/app/services/util.service';

export interface HasChecklist {
  id: string;
  checklist: LookupItem[];
}

export type ChecklistOrigem = "ATIVIDADE" | undefined;

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {

  public util: UtilService;

  constructor(public injector: Injector) {
    this.util = this.injector.get<UtilService>(UtilService);
  }

  public buildChecklist<T extends HasChecklist>(tipo: T, checklistControl?: AbstractControl) {
    let checks: Checklist[] = this.util.merge((tipo?.checklist || []).map(a => {
      return {
        id: a.key,
        texto: a.value,
        checked: false
      } as Checklist;
    }), (checklistControl?.value || []).filter((b: Checklist) => b.checked), (a: Checklist, b: Checklist) => {
      if (a.id == b.id) {
        a.checked = b.checked;
        return true;
      } else {
        return false;
      }
    });
    if (checklistControl) checklistControl.setValue(checks);
    return checks;
  }

  public addItemHandleChecklist(form: FormGroup): Checklist | undefined {
    let result = undefined;
    const checked = form.controls.checked.value;
    const texto = form.controls.texto.value;
    const detalhamento = form.controls.detalhamento.value;
    const anotacoes = form.controls.anotacoes.value;
    const id = this.util.textHash(texto);
    result = {
      id: id,
      checked: checked,
      texto: texto,
      detalhamento: detalhamento || "",
      anotacoes: anotacoes || ""
    };
    return result;
  };
  
  public addItemHandleMultiselect(inputList: AbstractControl, inputItem: AbstractControl): LookupItem | undefined {
    let result = undefined;
    const value = inputItem.value;
    const key = this.util.textHash(value);
    if(value?.length && this.util.validateLookupItem(inputList.value, key)) {
      result = {
        key: key,
        value: inputItem.value,
        data: {
          checked: false,
          annotation: "",
          details: ""
        }
      };
      inputItem.setValue("");
    }
    return result;
  };

  public fromLookupItem(items?: LookupItem[]): Checklist[] | undefined {
    return items?.map(x => Object.assign({}, {
      id: x.key,
      texto: x.value,
      checked: !!x.data?.checked,
      detalhamento: x.data?.details,
      anotacoes: x.data?.annotations
    } as Checklist));
  } 

  public toLookupItem(checks?: Checklist[]): LookupItem[] | undefined {
    return (checks || []).map(x => Object.assign({}, {
      key: x.id,
      value: x.texto,
      data: {
        checked: x.checked,
        details: x.detalhamento,
        annotations: x.anotacoes
      }
    } as LookupItem));
  }

}